import { Button, Flex, Form, Input, Typography } from 'antd';

import { useLoginFormField } from '@/features/auth/model/useLoginFormField';

import styles from './LoginFormField.module.css';

const { Title, Text } = Typography;

export const LoginFormField = () => {
  const {
    form,
    isLoading,
    isSubmitDisabled,
    onSubmit,
    handleKeyDown,
    isDemoMode,
    appliedUsernameRules,
    showPasswordField,
    passwordFieldRules,
  } = useLoginFormField();

  return (
    <Flex vertical gap="middle" style={{ width: '100%' }}>
      <Form form={form} onFinish={onSubmit} className={styles.loginForm} autoComplete="on">
        <Form.Item
          className={styles.formItem}
          name="username"
          rules={appliedUsernameRules}
          validateTrigger="onChange"
          validateFirst>
          <div>
            <label className={styles.label}>{isDemoMode ? '아이디' : '사용자 ID'}</label>
            <Input
              placeholder={isDemoMode ? '예: admin, manager, 또는 임의의 아이디' : '사용자 ID를 입력해 주세요'}
              className={styles.inputField}
              autoComplete="username"
              onKeyDown={handleKeyDown}
              size="large"
            />
          </div>
        </Form.Item>
        {showPasswordField ? (
          <Form.Item
            className={styles.formItem}
            name="password"
            rules={passwordFieldRules}
            validateTrigger="onChange"
            validateFirst>
            <div>
              <label className={styles.label}>비밀번호</label>
              <Input.Password
                placeholder={isDemoMode ? '관리자 비밀번호' : '비밀번호를 입력해 주세요'}
                className={styles.inputField}
                autoComplete="current-password"
                onKeyDown={handleKeyDown}
                size="large"
              />
            </div>
          </Form.Item>
        ) : null}
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            disabled={isLoading || isSubmitDisabled}
            className={styles.loginButton}
            size="large"
            block={isDemoMode}>
            {!isLoading && '로그인'}
          </Button>
        </Form.Item>
      </Form>

      {isDemoMode ? (
        <>
          <Title level={5} style={{ margin: 0 }}>
            권한 안내
          </Title>
          <Flex vertical gap="small">
            <Text code>admin + 비밀번호 → admin</Text>
            <Text code>manager → manager (비밀번호 없음)</Text>
            <Text code>그 외 아이디 → user</Text>
          </Flex>
        </>
      ) : null}
    </Flex>
  );
};
